import { isChatBetaEnabled } from "@/components/chat/featureFlag";

/** Leo 2026-10-01: chat off; Leo 10-26: on in dev builds only (buildspec-dev stamps VITE_BUILD_CHANNEL=dev,
 * prod stamps prod). Every chat entry point in the lane reads this. */
export const CHAT_ENABLED: boolean =
  import.meta.env.VITE_BUILD_CHANNEL === "dev" && isChatBetaEnabled();
